import mensCollection from '../../Assets/Img/mens-collection.webp';
import womensCollection from '../../Assets/Img/womens-collection.webp';
import Button from '../../Components/ui/Button/Button';
import { Container } from '../../Components/ui/Container/Container';
import Link from '../../Components/ui/Link/Link';
import Section from '../../Components/ui/Section/Section';
import { Skeleton } from '../../Components/ui/Skeleton';
import { Typography } from '../../Components/ui/Typography/Typography';
import { useTrackScreenView } from '../../Hooks/use-track-screen-view';
import {
    isNavCategoryWithGarments,
    NAV_CATEGORY_IDS,
    NAV_CATEGORY_TITLES,
    NavCategoryId,
    useGetCategories,
} from '../../Hooks/useGetCategories';
import styles from './index.module.scss';

const CATEGORY_IMAGES: Record<NavCategoryId, string> = {
    men: mensCollection,
    women: womensCollection,
};

const HomePage = () => {
    useTrackScreenView('screen_landing_view');

    const { isLoading, isError, data } = useGetCategories();

    const visibleCategoryIds: NavCategoryId[] = isError
        ? [...NAV_CATEGORY_IDS]
        : (data?.categories.filter(isNavCategoryWithGarments).map((category) => category.id) ?? []);

    console.log(isLoading);

    return (
        <Section top="sm" bottom="sm">
            <Container className={styles.bgGrey}>
                <div className={styles.collectionsContainer}>
                    <Typography variant="heading1" component="h1">
                        Every look. Instantly.{' '}
                    </Typography>
                    <Typography color="secondary" style={{ textAlign: 'center' }}>
                        Pick the styles you love and see exactly how each one looks on you, with
                        just one photo.
                    </Typography>
                    <div className={styles.collections}>
                        {isLoading
                            ? NAV_CATEGORY_IDS.map((id) => <CollectionCardSkeleton key={id} />)
                            : visibleCategoryIds.map((id) => (
                                  <CollectionCard
                                      key={id}
                                      title={NAV_CATEGORY_TITLES[id]}
                                      category={id}
                                      image={CATEGORY_IMAGES[id]}
                                  />
                              ))}
                    </div>
                </div>
            </Container>
        </Section>
    );
};

export default HomePage;

interface CollectionCardProps {
    title: string;
    category: NavCategoryId;
    image: string;
}

const CollectionCard = ({ title, category, image }: CollectionCardProps) => {
    return (
        <div className={styles.collectionCard}>
            <Link to={`/collections/${category}`}>
                <img src={image} alt={title} className={styles.image} />
            </Link>
            <div className={styles.cardFooter}>
                <Button variant="text" asChild>
                    <Link to={`/collections/${category}`}>{title}</Link>
                </Button>
            </div>
        </div>
    );
};

const CollectionCardSkeleton = () => (
    <div>
        <Skeleton width={400} height={400} />
        <div className={styles.cardFooter}>
            <Skeleton width={86} height={24} />
        </div>
    </div>
);
